module.exports = __webpack_public_path__ + "img/30.2419603d.jpg";